export default "/_next/static/e58ed8f86b9d1b5771538efff363a804.png";